"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertWorkLocationResponses = void 0;
function assertWorkLocationResponses(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(2);
    var workLocationsResponse = responses.find(function (r) { return r.questionId === 739651; });
    expect(workLocationsResponse.answer).toBe("502 JUNCTION");
    expect(workLocationsResponse.associatedId).toBe(26986);
    expect(workLocationsResponse.associatedRootId).toBeUndefined();
    expect(workLocationsResponse.questionId).toBe(739651);
    expect(workLocationsResponse.questionRootId).toBe(589901);
    expect(workLocationsResponse.associatedLocation.latitude).toBe(39.201412);
    expect(workLocationsResponse.associatedLocation.longitude).toBe(-79.271041);
    var emergencyResponse = responses.find(function (r) { return r.questionId === 739901; });
    expect(emergencyResponse.answer).toBe("123 Fake Street");
    expect(emergencyResponse.associatedId).toBeUndefined();
    expect(emergencyResponse.associatedRootId).toBeUndefined();
    expect(emergencyResponse.questionId).toBe(739901);
    expect(emergencyResponse.questionRootId).toBe(589903);
    expect(emergencyResponse.associatedLocation.latitude).toBe(123);
    expect(emergencyResponse.associatedLocation.longitude).toBe(123);
}
exports.assertWorkLocationResponses = assertWorkLocationResponses;
//# sourceMappingURL=workLocationResponses.js.map